<template>
  <div @mouseleave="mouseOver()">
    <!-- 人脸识别组件 -->
    <el-dialog :title="title" :visible.sync="cameraFalg" :show-close="false" :close-on-click-modal="false">
      <div class="cameraBox">
        <div class="box2">{{ text }}</div>
        <div style="" class="bkBox box3">
          <img v-if="showImg" :src="imgUrl" alt="" class="box5" />
          <video
            v-if="!showImg"
            ref="videoCamera"
            class="box23"
            id="videoCamera"
            :width="videoWidth"
            :height="videoHeight"
            autoplay
          ></video>
          <canvas id="canvasCamera" style="display: none" :width="videoWidth" :height="videoHeight"></canvas>
        </div>

        <div @click="setImage()" class="camerBtn">立即认证核验</div>
      </div>
    </el-dialog>
    <!-- end人脸识别组件 -->

    <!-- 后台偷拍组件 -->
    <div v-if="backCamera">
      <video
        v-if="backCamera"
        style="position: absolute; top: 0px; left: 0"
        ref="backCamera"
        id="backCamera"
        :width="videoWidth"
        :height="videoHeight"
        autoplay
      ></video>
      <canvas id="backCanvas" style="display: none" :width="videoWidth" :height="videoHeight"></canvas>
    </div>
    <div class="videoBanner" style="position: absolute; top: 0; width: 100%; height: 100%; background: #000000">
      <div class="videoHeader">
        <div class="backBox" @click="goBack">
          <div style="display: flex">
            <img src="../../../assets/images/back_icon.png" alt="安全生产学习平台" />
          </div>
          <div class="back_text">返回学习中心</div>
        </div>
        <div class="courseText">{{ videoInfo.chapterTitle || '' }}</div>
      </div>

      <div class="bannerBox" v-show="showVideo">
        <div class="videoBox" style="position: relative">
          <div v-show="!ccShow" ref="player" class="videoBox" id="videoPlayer1" @ended="endVideo(1)" @timeupdate="timeupdate"></div>
          <div v-show="ccShow" ref="player" class="videoBox" id="videoPlayer2"></div>

          <!-- <img
            style="position: absolute; top: 10px; right: 30px; z-index: 99999; width: 102px; height: 31px"
            src="../../../assets/indexImg/videoLogo.png"
            alt="安全生产学习平台"
          /> -->
          <div class="tips">
            <div class="tipsTitle">
              温馨提示
              <div></div>
            </div>

            <!-- <div class="margin25">1.此学习为提升性学习，不记录相关学时，若需继续教育学时请到报名选课页面进行报名；</div> -->
            <div class="margin25">1.如果视频无法播放，推荐使用360浏览器极速模式；</div>
            <div class="margin25">2.遇到任何学习问题都可拨打客服电话咨询；</div>
            <div class="margin25">3.学习过程中会随机进行人脸抓拍，请勿离开。</div>
            <!-- <div class="margin25">4.如您需要发票请到缴费订单管理界面申领电子发票。</div> -->
          </div>
        </div>

        <div class="directory">
          <div class="tipsTitle">
            目录
            <div></div>
          </div>

          <div>
            <!-- <div class="listBox_1" @click="seletZan(item)" :key="zanKey">
              <div class="ml8" style="color: #fff" :title="item.chapterTitle">{{ item.chapterTitle }}</div>
              <div class="mar38">
                <img class="mrw16" v-if="item.zan" src="../../../assets/listImgs/bottom_Icon.png" alt="" />
                <img class="mrw16" v-else src="../../../assets/listImgs/left_Icon.png" alt="" />
              </div>
            </div> -->
            <div style="width: 348px">
              <div
                class="listBox_1"
                style="margin-top: 10px"
                v-for="item in chapterList"
                :key="item.chapterId"
                @click="videoChange(item, 1)"
              >
                <div style="display: flex; justify-content: flex-end; height: 32px; padding: 0 10px">
                  <div v-if="item.studystatus == '03'">已完成</div>
                  <div v-if="item.studystatus != '03'" style="color: #438ce7">未完成</div>
                </div>
                <div style="display: flex">
                  <div style="display: flex; align-items: center" v-if="videoInfo.chapterId == item.chapterId">
                    <div class="play">当前播放</div>
                  </div>
                  <div class="ml8">{{ item.chapterTitle }}</div>
                </div>

                <!-- <div>未完成</div> -->
                <!-- <div class="mar38">{{ item.jindu }}%</div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import { Loading } from 'element-ui';
import 'xgplayer';
import hlsjsPlayer from 'xgplayer-hls.js';
import Player from 'xgplayer';
import {
  toStudy,
  updateDBTrack,
  getVideoUrl,
  getFaceConfig,
  compareAndSavePhoto,
  certImage,
  shanxiHealthScreenshot,
  studentCard,
  healthCertificate
} from '@/api/study.js';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      TMvalid: false, //是否需要验证码，false不需要
      dialogVisible: false, //验证码弹框
      codeNum: '', //验证码结果
      configKey: '', //tm平台需要的key
      codeImg: '', //验证码图片
      codeId: '', //提交验证码必要参数
      chapterid: '', //提交验证码必要参数
      tmId: '', //提交验证码必要参数
      coursePlayTimeList: [],
      isNeedVerify: '', //是否需要验证
      codeResTime: '', //验证时间
      codeIndex: '',
      userId: '',
      getVerCodeTime: 1, //1分钟
      everyProVideo: 15, //假定视频总长度
      isVerify_0: false, //
      verifyChapter: '',
      verCodeCount: 0,
      codeStatus: false, //验证码检查状态
      isGetTmVerCodeByVideoPlayTimer: null, //定时器
      options: {
        autoplay: true, // 设置自动播放
        muted: false, // 设置了它为true，才可实现自动播放,同时视频也被静音 （Chrome66及以上版本，禁止音视频的自动播放）
        preload: 'auto', // 预加载
        controls: true // 显示播放的控件
      },
      player: null,
      queryPams: {},
      chapterList: [], //目录
      coureseList: '',
      videoInfo: {}, //当前播放数据
      lessonstatus: '', //学习状态0
      videoTime: 0,
      timer: null,
      allInt: false, //视频是否已完成 false未完成 true已完成
      className: '1',
      t: false, //是pc还是移动端
      jinDuId: '', //动态渲染当前播放视频进度
      foj: '', //进度
      isExam: '',
      //以下是人脸识别需要的参数
      captureCount: '', //拍照次数
      faceConfigFlag: '02', //01开启 02关闭
      intervalSeconds: '', //间隔秒数
      cameraFalg: false,
      showImg: '',
      imgUrl: '',
      videoWidth: 470,
      videoHeight: 470,
      //相机截图工具
      face_back_canvas: null,
      //截图内容
      face_back_context: null,
      //照片的base64码值
      face_back_base64Photo: '',
      thisCancas: null,
      thisContext: null,
      thisVideo: null,
      userphoto: '', //用户的头像。拿拍照的图片和头像对比是否本人
      learn_faceMatch_backstagePhoto_score: '', //分数
      timeCream: null, //定时器拍照
      alreadyPhotoCount: '',
      ccShow: false,
      zanKey: 10,
      zanKey1: 940,
      backCamera: false,
      text: '需本人进行人脸认证核验后才能继续学习',
      title: '人脸识别',
      showVideo: true,
      showSb: false, //鼠标检测，false的时候不检测
      ruleStudyFocus: '01', //默认关闭
      faceConfigScreenShot: '02',
      backNum:0,//当前后台抓拍次数
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    //鼠标失焦
    mouseOver() {
      if (this.showSb && this.ruleStudyFocus == '02') {
        this.$alert('检测到鼠标移出本页面，该视频已暂停，请勿将鼠标移出，否则将无法播放！', '温馨提示', {
          confirmButtonText: '确定'
        });
        this.player.pause();
      }
    },
    //展开收起
    seletZan(item) {
      item.zan = !item.zan;
      console.log(item);
      this.zanKey = this.zanKey + 1;
      this.zanKey1 = this.zanKey1 + 10;
    },
    // 调用权限（打开摄像头功能）
    async getCompetence() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ video: true });
        this.$refs.videoCamera.srcObject = stream;
      } catch (error) {
        this.$alert('无法访问摄像头!，请确认电脑摄像头功能正常后再来学习~', '温馨提示', {
          confirmButtonText: '确定',
          callback: action => {
            this.$router.push({
              path: '/studyMain',
              query: {
                tabIndex: 8
              }
            });
            // this.$router.back();
          }
        });
      }
    },
    // 调用后台抓拍权限（打开摄像头功能）
    async getBackCompetence() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ video: true });
        this.$refs.backCamera.srcObject = stream;
        //2s之后自动拍照
        setTimeout(() => {
          this.backSetImg();
        }, 2000);
      } catch (error) {
        this.$alert('无法访问摄像头!，请确认电脑摄像头功能正常后再来学习~', '温馨提示', {
          confirmButtonText: '确定',
          callback: action => {
            // this.$router.back();
            this.$router.push({
              path: '/studyMain',
              query: {
                tabIndex: 8
              }
            });
          }
        });
      }
    },
    //  绘制图片（拍照功能）
    setImage() {
      let _this = this;
      let canvas = document.getElementById('canvasCamera');
      //相机截图工具
      _this.face_back_canvas = document.getElementById('canvasCamera');
      //截图内容
      _this.face_back_context = document.getElementById('canvasCamera').getContext('2d');
      try {
        let videow = document.getElementById('videoCamera').clientWidth;
        let videoh = document.getElementById('videoCamera').clientHeight;
        _this.face_back_canvas.setAttribute('width', videow);
        _this.face_back_canvas.setAttribute('height', videoh);
        _this.face_back_context.drawImage(document.getElementById('videoCamera'), 0, 0, videow, videoh);
        _this.face_back_base64Photo = canvas.toDataURL('image/jpeg', 1);
        console.log(_this.face_back_base64Photo);
        _this.showImg = true;
        _this.imgUrl = _this.face_back_base64Photo;
        _this.carmerShow = false;
        let data = {
          photoType: 'learn_facaMatch_backstagePhoto_pc',
          photoWay: 'photo_way_facaMatch',
          userphoto: _this.userphoto,
          base64Photo: _this.face_back_base64Photo,
          learn_faceMatch_backstagePhoto_score: _this.learn_faceMatch_backstagePhoto_score,
          classId: _this.queryPams.classId,
          courseWareId: _this.videoInfo.cwId,
          courseId: _this.videoInfo.courseId
        };
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
          loading.close();
        }, 10000);
        compareAndSavePhoto(data).then(res => {
          loading.close();
          //2025.08.29新逻辑
          if (res.data.data.isPassFlag) {
            _this.showVideo = true;
            _this.player.play();
            _this.cameraFalg = false;
            _this.imgUrl = '';
            _this.face_back_base64Photo = '';
            //判断如果是后台抓拍的，重新开启
            if (_this.title == '后台抓拍' && _this.backNum < _this.captureCount) {
              this.timeCream = setInterval(() => {
                // _this.player.pause(); //暂停视频
                // _this.showImg = false;
                // _this.cameraFalg = true;
                this.backCamera = true; //启动后台抓拍
                this.getBackCompetence(); //获取权限
                console.log('启动了后台抓拍');
              }, parseInt(this.intervalSeconds) * 1000);
            }
            setTimeout(() => {
              _this.showSb = true; //检测
            }, 2000);
          } else {
            _this.showSb = false; //不检测
            clearInterval(_this.timeCream);
            //没通过
            _this.player.pause(); //暂停视频
            _this.$message.error(res.data.data.msg);
            setTimeout(() => {
              _this.showImg = false;
              _this.imgUrl = '';
              _this.face_back_base64Photo = '';
              _this.getCompetence();
            }, 1000);
          }
        });
      } catch (e) {
        console.log(e);
      }
    },

    //后台偷拍绘制图片
    backSetImg() {
      let _this = this;
      let canvas = document.getElementById('backCanvas');
      //相机截图工具
      _this.face_back_canvas = document.getElementById('backCanvas');
      //截图内容
      _this.face_back_context = document.getElementById('backCanvas').getContext('2d');
      try {
        let videow = document.getElementById('backCamera').clientWidth;
        let videoh = document.getElementById('backCamera').clientHeight;
        _this.face_back_canvas.setAttribute('width', videow);
        _this.face_back_canvas.setAttribute('height', videoh);
        _this.face_back_context.drawImage(document.getElementById('backCamera'), 0, 0, videow, videoh);
        _this.face_back_base64Photo = canvas.toDataURL('image/jpeg', 1);
        let data = {
          photoType: 'learn_facaMatch_backstagePhoto_pc',
          photoWay: 'photo_way_facaMatch',
          userphoto: _this.userphoto,
          base64Photo: _this.face_back_base64Photo,
          learn_faceMatch_backstagePhoto_score: _this.learn_faceMatch_backstagePhoto_score,
          classId: _this.queryPams.classId,
          courseWareId: _this.videoInfo.cwId,
          courseId: _this.videoInfo.courseId
        };
        compareAndSavePhoto(data).then(res => {
          //拍照通过了
          if (res.data.data.isPassFlag) {
            _this.imgUrl = '';
            _this.face_back_base64Photo = '';
            _this.backNum = _this.backNum + 1//拍一次就+1
            console.log(_this.backNum,'当前拍了多少张抓拍了');
            
            //如果够了就不抓拍了
            if (_this.backNum >= _this.captureCount) {
              clearInterval(_this.timeCream);
              _this.backCamera = false;
              _this.timeCream = null
            }
          } else {
            //关闭定时器
            clearInterval(_this.timeCream);
            _this.timeCream = null;
            //没通过
            _this.player.pause(); //暂停视频显示拍照组件
            _this.showSb = false; //不检测
            _this.$message.error('未检测到人脸，学习已暂停！请重新进行人脸识别');
            setTimeout(() => {
              _this.text = '学习过程中会随机进行人脸抓拍，请勿离开。';
              _this.title = '后台抓拍';
              _this.showVideo = false;
              _this.cameraFalg = true;
              _this.showImg = false;
              _this.imgUrl = '';
              _this.face_back_base64Photo = '';
              _this.getCompetence();
            }, 1500);
          }
        });
      } catch (e) {
        console.log(e);
      }
    },
    //获取人脸识别参数
    getFaceConfig() {
      getFaceConfig().then(res => {
        this.captureCount = res.data.data.captureCount;
        this.alreadyPhotoCount = res.data.data.alreadyPhotoCount;
        this.faceConfigFlag = res.data.data.faceConfigFlag;
        this.intervalSeconds = res.data.data.intervalSeconds;
        this.userphoto = res.data.data.userPhoto; //头像
        this.learn_faceMatch_backstagePhoto_score = res.data.data.faceConfigScore; //分数
        this.ruleStudyFocus = res.data.data.ruleStudyFocus;
        this.faceConfigScreenShot = res.data.data.faceConfigScreenShot; //后台抓拍控制
        if (this.userphoto == '') {
          this.showVideo = false;
          this.$alert('该学习需要进行人脸识别，请先上传本人头像后再来学习！', '温馨提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.$router.back();
            }
          });
          return false;
        }
        console.log('后台抓拍', this.faceConfigScreenShot == '01', parseInt(this.intervalSeconds) * 1000);
        //后台抓拍单独判断
        if (this.faceConfigScreenShot == '01') {
          this.timeCream = setInterval(() => {
            // _this.player.pause(); //暂停视频
            // _this.showImg = false;
            // _this.cameraFalg = true;
            this.backCamera = true; //启动后台抓拍
            this.getBackCompetence(); //获取权限
            console.log('启动了后台抓拍');
          }, parseInt(this.intervalSeconds) * 1000);
        }
        //人脸识别，根据字段
        if (this.faceConfigFlag == '01') {
          // this.showVideo = false;
          if (this.ruleStudyFocus == '02') {
            this.showSb = false;
          } else {
            this.showSb = false;
          }
          setTimeout(() => {
            this.getCompetence();
            this.cameraFalg = true;
            if (this.ccShow) {
              //7s后暂停视频,因为视频需要加载给个缓存时间
              this.player.pause();
            } else {
              this.player.pause();
            }
          }, 5 * 1000);
        } else {
          if (this.ruleStudyFocus == '02') {
            this.showSb = true;
          } else {
            this.showSb = false;
          }
          this.cameraFalg = false;
          return false;
        }
      });
    },
    goBack() {
      this.$router.push({
        path: '/studyMain',
        query: {
          trainSubjectId: this.$route.query.trainSubjectId
        }
      });
    },
    videoChange(item, t) {
      console.log(item, '2222555');
      
      const toStudyData = {
        classId: this.$route.query.classId,
        courseId: this.$route.query.courseId,
        cwId: item.cwId
      };
      setTimeout(() => {
        toStudy(toStudyData)
          .then(toStudyRes => {
            this.chapterList = toStudyRes.data.data;
            // this.getVideotime(item);
          })
          .catch(toStudyErr => {});
      }, 2000);

      // 保存上一个视频的播放记录
      this.videoInfo = {
        chapterId: item.chapterId,
        chapterTitle: item.chapterTitle,
        courseId: this.$route.query.courseId,
        cwId: item.cwId,
        period: item.period,
        chapterhours: item.hours,
        jindu: item.jindu
      };

      const params = {
        classId: this.$route.query.classId,
        courseId: this.$route.query.courseId,
        cwId: item.cwId
      };
      this.getVideo(item);
      // toStudy(params)
      //   .then(res => {
      //     if (res.data.code === 200) {
      //       const videoData = res.data.data;
      //       const isCompleted = videoData.jindu === 100;
      //       this.videoInfo = videoData;

      //     }
      //   })
      //   .catch(err => {
      //     console.error('获取视频信息失败:', err);
      //   });

      window.scrollTo(0, 0);
      //10s后调用人脸识别参数
      setTimeout(() => {
        this.getFaceConfig()
      }, 10*1000);
      this.$forceUpdate();

    },
    // 视频结束事件
    endVideo(t) {
      this.getVideotime(); // 记录当前视频的播放位置
      this.allInt = true; // 标记当前视频已完成
      const currentVideo = this.chapterList.find(item => item.chapterId === this.videoInfo.chapterId);
      if (currentVideo) {
        currentVideo.jindu = 100; // 设置进度为 100%
        currentVideo.studystatus = '03';
        console.log(currentVideo, currentVideo.studystatus, '学习状态');
      }
      // 自动切换到下一个视频
      this.playNextVideo();
    },
    getData(t) {
      this.queryPams.classId = this.$route.query.classId;
      this.queryPams.cwId = this.$route.query.cwId;
      this.queryPams.courseId = this.$route.query.courseId;
      console.log(this.queryPams.courseId);

      if (this.queryPams.classId == undefined) {
        return false;
      }
      toStudy({ classId: this.queryPams.classId, cwId: this.queryPams.cwId, courseId: this.queryPams.courseId }).then(res => {
        if (res.data.code == 200) {
          this.chapterList = res.data.data;
          console.log(this.chapterList, 'wwww');
          // 播放 cwId 对应的课程
          if (this.queryPams.cwId) {
            const targetChapter = this.chapterList.find(item => item.cwId === this.queryPams.cwId);
            if (targetChapter) {
              this.videoChange(targetChapter, 1);
              return;
            }
          }
          // 遍历 chapterList 找到第一个进度不等于 100 的视频
          // let targetVideo = null;
          // for (let i = 0; i < this.chapterList.length; i++) {
          //   const chapter = this.chapterList[i];
          //   this.chapterList[i].zan = false;
          //   // if (!chapter.chapterList || chapter.chapterList.length === 0) continue;
          //   // for (let j = 0; j < chapter.chapterList.length; j++) {
          //   //   const video = chapter.chapterList[j];
          //     if (chapter.jindu !== 100) {
          //       this.chapterList[i].zan = true;
          //       targetVideo = chapter;
          //       break;
          //     }
          //   // }

          //   if (targetVideo) break;
          // }

          // // 如果没有找到对应cwid的视频，默认选择第一个视频
          if (!targetChapter) {
            if (this.chapterList.length > 0) {
              targetVideo = this.chapterList[0];
              this.chapterList[0].zan = true;
            } else {
              return;
            }
          }

          this.coureseList = this.chapterList.map(item => item.chapterList[0]);
        }
      });
    },
    setupPlayerEvents() {
      let _this = this;

      _this.player.on('ended', function () {
        _this.endVideo(1);
      });

      _this.player.on('timeupdate', function () {
        _this.timeupdate();
      });
    },
    getVideo(videoUrl) {
      console.log(videoUrl, 'ssss');
      if (videoUrl.viewId !== '' && videoUrl.viewId !== null) {
        this.ccShow = true;
        //是cc视频的,清空西瓜
        // this.player.destroy('videoPlayer1');
        let elems = document.getElementById('videoPlayer2');
        let data = {
          vid: videoUrl.viewId,
          siteid: videoUrl.stateId,
          autoStart: true,
          // realAutoPlay:true,
          parentNode: elems,
          rate_allow_change: false,
          progressbar_enable: 0, //0禁止拖动，1可以拖动
          closeHistoryTime: 1,
          watchStartTime: 0, //断点续播
          showFullScreenBtn: false //禁止全屏
        };
        if (videoUrl.jindu >= 100) {
          //该视频已经播放完毕了
          data.progressbar_enable = 1;
          data.watchStartTime = 0;
        } else {
          data.progressbar_enable = 0;
          data.watchStartTime = videoUrl.hours;
        }
        this.player = createCCH5Player(data);
        setTimeout(() => {
          this.player.play();
        }, 1000);
        return false;
      }

      if (this.player !== null) {
        this.ccShow = false;
        this.player.destroy('videoPlayer1');
      }
      let playUrl = '';
      if (videoUrl.sourceVideo == '01' || videoUrl.sourceVideo == '02') {
        const data = {
          courseId: videoUrl.courseId,
          chapterId: videoUrl.chapterId
        };
        getVideoUrl(data).then(res => {
          const videoLaunch = res.data.data.launch;
          this.player = new Player({
            id: 'videoPlayer1',
            autoplay: true,
            playsinline: true,
            url: videoLaunch,
            progressDisabled: true
          });
          // 已完成则从 0 开始
          this.player.currentTime = isCompleted ? 0 : videoUrl.hours || 0;
          // 当未完成时禁用进度条
          if (!isCompleted) {
            this.player.once('play', () => {
              const progressEl = document.getElementsByClassName('xgplayer-progress')[0];
              if (progressEl) {
                progressEl.style.pointerEvents = 'none';
              }
            });
          }
          this.player.play();
          this.setupPlayerEvents(); // 提取事件绑定
        });
      } else {
        if (/\.m3u8$/.test(videoUrl.launch)) {
          this.player = new hlsjsPlayer({
            id: 'videoPlayer1',
            autoplay: true,
            playsinline: true,
            url: videoUrl.launch,
            progressDisabled: true
          });
        } else {
          playUrl = videoUrl.launch + '.mp4';
          this.player = new Player({
            id: 'videoPlayer1',
            autoplay: true,
            playsinline: true,
            url: playUrl,
            progressDisabled: true
          });
        }
        // 已完成则从 0 开始
        this.player.currentTime = videoUrl.jindu >= 100 ? 0 : videoUrl.hours;
        // 仅当未完成时禁用进度条
        if (videoUrl.jindu < 100) {
          this.player.once('play', () => {
            const progressEl = document.getElementsByClassName('xgplayer-progress')[0];
            if (progressEl) {
              progressEl.style.pointerEvents = 'none';
            }
          });
        }
        this.player.play();
        this.setupPlayerEvents();
        let _this = this;
        _this.player.on('loadstart', function () {
          //用户没头像
          if (_this.userphoto == '') {
            setTimeout(() => {
              _this.player.pause();
            }, 2000);
          } else {
            //需要人脸识别并且照片没拍够
            if (_this.faceConfigFlag == '01' && _this.alreadyPhotoCount < parseInt(_this.captureCount)) {
              setTimeout(() => {
                _this.player.pause();
              }, 2000);
            }
          }
        });
      }
    },
    // 获取当前视频播放位置
    timeupdate(e) {
      // this.videoTime = this.videoTime + 0.25;
      // if (this.player.currentTime - (this.videoInfo.chapterhours + this.videoTime) > 10) {
      //   this.player.currentTime = this.videoInfo.chapterhours + this.videoTime;
      // }
    },
    // 记录学时
    getVideotime(item) {
      if (this.videoInfo.jindu == 100) {
        return;
      }
      if (this.player == null) {
        return false;
      }
      // if (this.player.currentTime == undefined || this.player.currentTime == null) {
      //   return false;
      // }

      // 判断是否是CC视频播放器
      let currentTime;
      if (this.ccShow) {
        currentTime = this.player.getPosition();
      } else {
        currentTime = this.player.currentTime;
      }

      const lessonStatus = currentTime >= this.videoInfo.period ? 'completed' : 'incomplete';
      let data = {
        position: currentTime.toFixed(2), // 当前播放位置
        duration: this.videoInfo.period.toFixed(2),
        courseId: this.videoInfo.courseId,
        coursewareId: this.videoInfo.cwId,
        chapterId: this.videoInfo.chapterId,
        classId: this.$route.query.classId,
        lessonStatus
      };
      // const toStudyData = {
      //   classId: this.$route.query.classId,
      //   courseId: this.$route.query.courseId,
      //   cwId: this.$route.query.cwId
      // };
      // toStudy(toStudyData)
      //   .then(toStudyRes => {
      //     this.chapterList = toStudyRes.data.data;
      updateDBTrack(data)
        .then(res => {
          // 记录学时成功后，调用toStudy接口重置视频的起始时间

          if (res.data.data.certId != '' && res.data.data.certId != null) {
            let query = {
              userId: res.data.data.userId,
              orderId: res.data.data.orderId
            };
            //证书编号有值时调后端接口截图
            //承诺书
            this.getHealthCertificate(query);
            //学籍卡
            this.getStudentCard(query);
            query.certId = res.data.data.certId;
            //针对西安特殊情况的申请表，必须学完才能截图
            this.getShanxiHealthScreenshot(query);
            //学时截图
            setTimeout(() => {
              this.getCertImage(query);
            }, 2000);
          }
        })
        .catch(err => {
          console.error('学时记录失败:', err);
        });
      console.log(this.chapterList, '重置');
      // })
      // .catch(toStudyErr => {});
    },

    async playNextVideo() {
      const currentVideoIndex = this.chapterList.findIndex(video => video.chapterId === this.videoInfo.chapterId);
      if (currentVideoIndex === -1) {
        console.warn('当前视频不在章节列表中');
        return;
      }
      this.getVideotime();
      const currentVideo = this.chapterList[currentVideoIndex];
      if (currentVideo) {
        currentVideo.jindu = 100;
        currentVideo.studystatus = '03';
      }
      let targetVideo = null;
      for (let i = 0; i < currentVideoIndex; i++) {
        const video = this.chapterList[i];
        if (video.jindu < 100 || video.studystatus !== '03') {
          targetVideo = video;
          break; // 找到第一个就跳
        }
      }

      //  如果前面没有未完成的，再找后面的
      if (!targetVideo) {
        for (let i = currentVideoIndex + 1; i < this.chapterList.length; i++) {
          const video = this.chapterList[i];
          if (video.jindu < 100 || video.studystatus !== '03') {
            targetVideo = video;
            break;
          }
        }
      }

      if (targetVideo) {
        this.videoChange(targetVideo, 1);
        return;
      }
      this.$message.success('当前课程均已学习完成！');
      // try {
      //   const res = await toStudy({
      //     classId: this.$route.query.classId,
      //     courseId: this.$route.query.courseId,
      //     cwId: this.videoInfo.cwId
      //   });
      //   if (res.data?.code === 200) {
      //     this.chapterList = res.data.data;
      //     const anyUnfinished = this.chapterList.some(v => v.jindu < 100);
      //     if (anyUnfinished) {
      //       const firstUnfinished = this.chapterList.find(v => v.jindu < 100);
      //       if (firstUnfinished) {
      //         this.videoChange(firstUnfinished, 1);
      //       }
      //     }
      //   }
      // } catch (error) {
      //   console.error('刷新章节列表失败:', error);
      // }
    },
    startRecordingInterval() {
      this.timer = setInterval(() => {
        this.getVideotime();
      }, 2 * 60 * 1000); // 每5分钟
    },
    stopRecordingInterval() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    on_CCH5player_ended() {
      console.log(1);
      this.getVideotime(); // 记录当前视频的播放位置
      this.allInt = true; // 标记当前视频已完成
      const currentVideo = this.chapterList.find(item => item.chapterId === this.videoInfo.chapterId);
      if (currentVideo) {
        currentVideo.jindu = 100; // 设置进度为 100%
      }
      // 自动切换到下一个视频
      this.playNextVideo();
    },
    //学时证明截图
    getCertImage(data) {
      certImage(data).then(res => {
        console.log('截图了学时证明');
        
        if (res.data.msg == '500') {
          setTimeout(() => {
            this.getCertImage(data);
          }, 10 * 1000);
        }
      });
    },
    //承诺书
    getHealthCertificate(data) {
      healthCertificate(data).then(res => {
        console.log('截图了承诺书');
        
        if (res.data.msg == '600') {
          setTimeout(() => {
            this.getHealthCertificate(data);
          }, 10 * 1000);
        }
      });
    },
    //学籍卡
    getStudentCard(data) {
      studentCard(data).then(res => {
        console.log('截图了学籍卡');
        
        if (res.data.msg == '700 ') {
          setTimeout(() => {
            this.getStudentCard(data);
          }, 10 * 1000);
        }
      });
    },
    //针对西安特殊情况的申请表，必须学完才能截图
    getShanxiHealthScreenshot(data) {
      shanxiHealthScreenshot(data).then(res => {
        console.log('截图了西安特殊情况的申请表');
        
        if (res.data.msg == '800') {
          setTimeout(() => {
            this.getShanxiHealthScreenshot(data);
          }, 10 * 1000);
        }
      });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    //获取人脸识别参数
    // this.getFaceConfig();
  },
  destroyed() {
    clearInterval(this.timeCream);
    clearInterval(this.timer);
    this.timer = null;
    this.timeCream = null;
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.startRecordingInterval(); // 开始定时记录

    setTimeout(() => {
      this.getData();
      window.on_CCH5player_ended = this.on_CCH5player_ended;
    }, 1000);
  },

  // 生命周期 - 组件销毁前
  beforeDestroy() {
    this.stopRecordingInterval();
    if (!this.allInt) {
      this.getVideotime(); // 离开页面时记录播放位置
    }
    if (this.player) {
      this.player.destroy();
    }
    if (this.player !== null) {
      this.player.destroy('videoPlayer1');
    }
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
/deep/ .xgplayer-fullscreen {
  display: none !important;
}
.mrw16 {
  width: 16px;
  height: 16px;
  margin-top: 14px;
}
.videoHeader {
  height: 60px;
  background: #1c2127;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.27);
  opacity: 1;
  border-radius: 0px;
  padding: 15px 30px;
  display: flex;
  .backBox {
    width: 140px;
    height: 30px;
    background: #438ce7;
    opacity: 1;
    border-radius: 15px;
    font-size: 14px;
    color: #fff;
    display: flex;
    align-items: center;
    padding-left: 19px;
    cursor: pointer;
    img {
      width: 15px;
      height: 15px;
    }
    .back_text {
      margin-left: 8px;
      font-size: 14px;
    }
  }
  .courseText {
    margin-left: 12px;
    color: #bfc5c9;
    display: flex;
    align-items: center;
  }
}

.bannerBox {
  padding: 0 0 0 30px;
  display: flex;
  background: #000000;
  .videoBox {
    margin-top: 20px !important;
    width: 1460px !important;
    height: 590px !important;
    opacity: 1;
    border-radius: 0px;
  }

  .tips {
    width: 1480px !important;
    margin-top: 20px;
    height: 200px;
    background: #1c2127;
    padding: 8px 22px;
    color: #bfc5c9;
    font-size: 14px;
    .tipsTitle {
      font-size: 16px;
      position: relative;
      z-index: 2;
      div {
        position: absolute;
        width: 64px;
        height: 6px;
        background: linear-gradient(270deg, rgba(21, 109, 232, 0) 0%, #156de8 100%);
        opacity: 1;
        border-radius: 0px;
        bottom: 3px;
        z-index: -1;
      }
    }
    .margin25 {
      margin-top: 16px;
    }
  }
  .directory::-webkit-scrollbar {
    width: 5px; //修改滚动条宽度
  }
  .directory::-webkit-scrollbar-thumb {
    border-radius: 8px;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #666666;
  }
  //鼠标移入样式
  .directory::-webkit-scrollbar-thumb:hover {
    background: #333333;
  }

  .directory {
    width: 418px;
    height: 850px;
    overflow-y: scroll;
    overflow-x: hidden;
    background: #1c2127;
    margin-left: 20px;
    padding: 30px 20px;
    color: #bfc5c9;
    font-size: 14px;

    .tipsTitle {
      font-size: 16px;
      position: relative;
      z-index: 2;
      margin-bottom: 10px;
      div {
        position: absolute;
        width: 64px;
        height: 6px;
        background: linear-gradient(270deg, rgba(21, 109, 232, 0) 0%, #156de8 100%);
        opacity: 1;
        border-radius: 0px;
        bottom: 3px;
        z-index: -1;
      }
    }
    .listBox_1 {
      margin-top: 20px;
      width: 348px;
      height: auto;
      background: rgba(255, 255, 255, 0.05);
      border-radius: 4px;
      color: #bfc5c9;
      padding: 4 10px;
      line-height: 44px;
      display: flex;
      flex-direction: column;
      cursor: pointer;
      justify-content: space-between;
      .ml8 {
        width: 338px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-left: 8px;
      }
      .mar38 {
        margin-left: 30px;
        margin-right: 10px;
      }
      .play {
        width: 66px;
        height: 24px;
        background: #438ce7;
        opacity: 1;
        border-radius: 12px;
        text-align: center;
        line-height: 24px;
        font-size: 12px;
      }
    }
  }
}

.cameraBox {
  padding: 0 25px;
  font-family: Medium;
  font-size: 16px;
  .bkBox {
    display: flex;
    justify-content: center;
    position: relative;
    .bk {
      position: absolute;
      top: 0;
      left: 0;
    }
    .box5 {
      margin-top: 10px;
    }
  }
  .camerBtn {
    width: 180px;
    height: 50px;
    background: #4275f5;
    opacity: 1;
    border-radius: 25px;
    font-family: Medium;
    font-size: 16px;
    color: #fff;
    text-align: center;
    line-height: 50px;
    cursor: pointer;
    margin: 28px auto auto auto;
  }
}
.camera_outer {
  position: relative;
  overflow: hidden;
  // background: url("../../assets/img/user_0608_04.png") no-repeat center;
  background-size: 100%;

  video,
  canvas,
  .tx_img {
    -moz-transform: scaleX(-1);
    -webkit-transform: scaleX(-1);
    -o-transform: scaleX(-1);
    transform: scaleX(-1);
  }

  .btn_camera {
    position: absolute;
    bottom: 4px;
    left: 0;
    right: 0;
    height: 50px;
    background-color: rgba(0, 0, 0, 0.3);
    line-height: 50px;
    text-align: center;
    color: #ffffff;
  }

  .bg_r_img {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
  }

  .img_bg_camera {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;

    img {
      width: 300px;
      height: 300px;
    }

    .img_btn_camera {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 50px;
      line-height: 50px;
      text-align: center;
      background-color: rgba(0, 0, 0, 0.3);
      color: #ffffff;

      .loding_img {
        width: 50px;
        height: 50px;
      }
    }
  }
}
</style>
